import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '@core/auth/auth-service/auth-service'
import { USER_TYPES } from '@core/data/models'

export const hasUserTypeGuard = (allowedTypes: USER_TYPES[]): CanActivateFn => {
  return async () => {
    const router = inject(Router)
    const authService = inject(AuthService)

    // Only initialize if no user is loaded yet
    if (!authService.currentUser()) {
      await authService.initialize()
    }

    const userType = authService.currentUser()?.userType

    if (userType != null && allowedTypes.includes(userType)) {
      return true
    }

    router.navigate(['/championships'])
    return false
  }
}
